import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _16mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"16mp"}/>
}
